import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Constants } from '../../helper/constants';
import { LetterService } from '../../services/letter.service';
import { GlobalObservables } from '../../../../app.global.observer';
import { Global } from '../../../../app.global';
import { BespokeLetterModel } from '../../viewmodels/bespoke-letter.model';
import { DecisionsConst } from '../../helper/decisionsConst';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'bespoke-letter',
  templateUrl: './bespoke-letter.component.html',
  styleUrls: ['./bespoke-letter.component.scss'],
})
export class BespokeLetterComponent implements OnInit {
  @Input() decision: string = this.decisionsConst.upheld.id;
  @Input() ckeConfig: any;
  @Output() submitBespokeLetter: EventEmitter<any> = new EventEmitter<any>();
  @Output() closeModal: EventEmitter<any> = new EventEmitter<any>();

  public constants = Constants;
  explanation = '';
  cancelOptions: any;
  encloseRefund: any;
  pinNumber: any;
  tpt: any;
  tptWebPortal: any;
  infoDetails = '';
  bespokeLetter = new BespokeLetterModel();
  yesNoOptions = [
    {
      id: 'y',
      caption: 'Yes',
    },
    {
      id: 'n',
      caption: 'No',
    },
  ];
  bespokeFieldsObject = {
    encloseRefund: false,
    pinNumber: false,
    tpt: false,
    tptText: '',
    tptWebPortal: false,
    tptWebPortalText: '',
  };

  constructor(
    public globalObs: GlobalObservables,
    public global: Global,
    private modalService: NgbModal,
    private letterService: LetterService,
    public decisionsConst: DecisionsConst
  ) {}

  ngOnInit() {
    this.setCancelOptions();

    this.setEncloseRefund();
    this.setPinNumber();
    this.setTpt();
    this.setTptWebPortal();

    this.getShowBespokeFields();
  }

  setCancelOptions() {
    this.cancelOptions = {
      optionSelected: 'n',
      optionList: this.yesNoOptions,
    };
  }

  setEncloseRefund() {
    this.encloseRefund = {
      optionSelected: 'n',
      optionList: this.yesNoOptions,
    };
  }

  setPinNumber() {
    this.pinNumber = {
      optionSelected: 'n',
      optionList: this.yesNoOptions,
    };
  }

  setTpt() {
    this.tpt = {
      optionSelected: 'n',
      optionList: this.yesNoOptions,
    };
  }

  setTptWebPortal() {
    this.tptWebPortal = {
      optionSelected: 'n',
      optionList: this.yesNoOptions,
    };
  }

  getShowBespokeFields() {
    this.letterService.getShowBespokeFields().subscribe((bespokeFieldsObject) => {
      this.bespokeFieldsObject = bespokeFieldsObject;
    });
  }

  getDecisionText() {
    if (this.decision === this.decisionsConst.upheld.id) {
      return this.decisionsConst.upheld.name;
    } else if (this.decision === this.decisionsConst.cancel.id) {
      return this.decisionsConst.cancel.name;
    }
    return this.decisionsConst.reqInfo.name;
  }

  changeDecisionStatus(decision) {
    this.decision = decision;
  }

  isBespokeLetterAllowed() {
    if (this.decision === this.decisionsConst.reqInfo.id && this.infoDetails.length < 5) {
      return false;
    }
    return true;
  }

  onSubmitBespokeLetter() {
    if (!this.isBespokeLetterAllowed) {
      return;
    }
    this.bespokeLetter = {
      decisionId: this.getDecisionIdFromDescription(this.decision),
      explanation: this.explanation,
      infoDetails: this.infoDetails,
      cancelOptionAnswer: this.cancelOptions.optionSelected,
      pinNumberAnswer: this.pinNumber.optionSelected,
      encloseRefundAnswer: this.encloseRefund.optionSelected,
      tptAnswer: this.tpt.optionSelected,
      tptWebPortalAnswer: this.tptWebPortal.optionSelected,
    };
    this.submitBespokeLetter.emit(this.bespokeLetter);
  }

  getDecisionIdFromDescription(decision) {
    if (decision !== undefined) {
      if (decision === this.decisionsConst.upheld.id) {
        return 1;
      } else if (decision === this.decisionsConst.cancel.id) {
        return 2;
      } else {
        return 3;
      }
    }
    return 1;
  }

  onCloseModal() {
    this.closeModal.emit();
  }
}
